import React, { Fragment, useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { compose } from "redux";
import { CircularProgress } from "@material-ui/core";
import { REQPVDDetail } from "./redux/actions";
import Table from "./table";
import { aColUntHld } from "./list_of_columns";
import Images from "../../utils/styles/images";
import "./style.scss";
import Pagination from "./Pagination";

function AnalyticPVDDetail(props) {
    const {
        REQPVDDetail,
        REQStrPVDList,
        PVDList,
        UISearch,
        totalPVDList,
        history
    } = props;
    const tColumePVD = React.useMemo(() => aColUntHld, []);
    const [tSrch, SETxSrch] = useState("");
    const [tOpSrch, SETxOpSrch] = React.useState("Email");
    const [nPageIndex, SETxPageIndex] = useState(0);
    const [tSortH, SETtSortH] = useState("creUpdatedAt DESC");

    const [isPageReload, setIsPageReload] = useState(false);
    const [isUnloading, setIsUnloading] = useState(false);

    useEffect(() => {
        const savePageState = () => {
            const dataFromList = JSON.parse(localStorage.getItem('currentAnalyticPVDDetail'))
            console.log("dataFromList", dataFromList)
            localStorage.setItem('currentAnalyticPVDDetail', JSON.stringify(dataFromList));
        };

        // Save initial state
        savePageState();

        const handleBeforeUnload = () => {
            savePageState();
        };

        const handlePageShow = (event) => {
            if (!event.persisted) {
                const storedData = JSON.parse(localStorage.getItem('currentAnalyticPVDDetail'));
                if (storedData) {
                    console.log("stored", storedData)
                }
            }
        };

        // Check for page reload using Performance API
        const navigationType = window.performance.getEntriesByType("navigation")[0]?.type;
        if (navigationType === 'reload') {
            setIsPageReload(true);
            const storedData = JSON.parse(localStorage.getItem('currentAnalyticPVDDetail'));
            if (storedData) {
                console.log("storedData", storedData)
                history.push(`/AnalyticPVDDetail`);
            }
        }

        // Handle navigation events
        const unlisten = history.listen((location, action) => {
            if (action === 'POP' && !isPageReload && !isUnloading) {
                history.replace({
                    pathname: "Analytic_PVD_Con",
                    PageCurrent: PageCurrent,
                    UISearch: UISearch
                });
            }
        });

        window.addEventListener('beforeunload', handleBeforeUnload);
        window.addEventListener('pageshow', handlePageShow);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
            window.removeEventListener('pageshow', handlePageShow);
            unlisten();

            if (!isPageReload && !isUnloading) {
                localStorage.removeItem('currentAnalyticPVDDetail');
            }
        };
    }, []);

    const CALLxAnalyticPVDDetail = () => {
        const dataFromList = JSON.parse(localStorage.getItem('currentAnalyticPVDDetail'))
        if (history.location.PageCurrent === undefined) {
            SETxPageIndex(0);
            REQPVDDetail({
                page: "1",
                tAccStatusCodeType: dataFromList.AccStatusCodeType,
                tStartD: dataFromList.UISearch.tStartD,
                tEndD: dataFromList.UISearch.tEndD,
                bAllD: dataFromList.UISearch.bAllD,
                tSrch,
                tOpSrch,
                tSortH
            });
        } else {
            let nPage = history.location.PageCurrent + 1;
            if (history.location.pathname === "/Analytic_PVD_Con") {
                SETxOpSrch(history.location.UISearch.tOpSrch);
                SETxSrch(history.location.UISearch.tSrch);

                SETxPageIndex(history.location.PageCurrent);
                REQPVDDetail({
                    page: nPage.toString(),
                    tAccStatusCodeType: dataFromList.AccStatusCodeType,
                    tStartD: dataFromList.UISearch.tStartD,
                    tEndD: dataFromList.UISearch.tEndD,
                    bAllD: dataFromList.UISearch.bAllD,
                    tSrch: history.location.UISearch.tSrch,
                    tOpSrch: history.location.UISearch.tOpSrch,
                    tSortH: history.location.UISearch.tSortH
                });
            }
        }
    };

    const SRCHxPVDAct = () => {
        SETxPageIndex(0);
        REQPVDDetail({
            page: "1",
            tAccStatusCodeType: history.location.AccStatusCodeType,
            tStartD: history.location.UISearch.tStartD,
            tEndD: history.location.UISearch.tEndD,
            bAllD: history.location.UISearch.bAllD,
            tSrch,
            tOpSrch,
            tSortH
        });
    };

    const SRCHxPVDActClr = () => {
        SETxSrch("");
        SETxPageIndex(0);
        REQPVDDetail({
            page: "1",
            tAccStatusCodeType: history.location.AccStatusCodeType,
            tStartD: history.location.UISearch.tStartD,
            tEndD: history.location.UISearch.tEndD,
            bAllD: history.location.UISearch.bAllD,
            tSrch: "",
            tOpSrch,
            tSortH
        });
    };

    const RadioInput = ({ label, value, checked, setter }) => {
        return (
            <span>
                <input
                    type="radio"
                    checked={checked === value}
                    onChange={() => {
                        setter(value);
                    }
                    }
                />
                <span style={{ marginLeft: 0 }}>{label}</span>
            </span>
        );
    };

    const columnSortDirections = {
        "REGISTER DATE": ["created_at ASC", "created_at DESC"],
        "USERNAME": ["username ASC", "username DESC"],
        "E-MAIL": ["email ASC", "email DESC"],
        "ACCOUNT TYPE": ["hasConverted ASC", "hasConverted DESC"],
        "UNITHOLDER": ["UnitCount ASC", "UnitCount DESC"]
    };

    const SETxActHeaderClick = (cell) => {
        const sortDirections = columnSortDirections[cell];
        if (sortDirections) {
            const currentSort = tSortH;
            const newSort = sortDirections.find((direction) => direction !== currentSort) || sortDirections[0];
            SETtSortH(newSort);
        }
    };

    const SETxActTableClick = (cellValue, rowData, columnName) => {
        if (columnName === "EMAIL") {
            console.log('SETxActTableClick > columnName === "EMAIL"');
        }
    };

    const SETxPageGo = pnPageAt => {
        let nPageAt = pnPageAt + 1;

        SETxPageIndex(pnPageAt);
        REQPVDDetail({
            page: nPageAt.toString(),
            tAccStatusCodeType: history.location.AccStatusCodeType,
            tStartD: history.location.UISearch.tStartD,
            tEndD: history.location.UISearch.tEndD,
            bAllD: history.location.UISearch.bAllD,
            tSrch,
            tOpSrch,
            tSortH
        });
    };

    const CALxPaging = () => {
        let nPageCnt = Math.ceil(totalPVDList / 10);
        return nPageCnt > 1 ? (
            <Pagination
                nPageIndex={nPageIndex}
                total={nPageCnt}
                gotoPage={SETxPageGo}
            />
        ) : null;
    };

    const GETxWidthSrch = () => {
        if (tOpSrch === "UUID") {
            return 450;
        } else {
            return 331;
        }
    };

    useEffect(() => {
        CALLxAnalyticPVDDetail();
        return () => {
            if (history.action === "POP") {
                history.replace({ pathname: "/Analytic_PVD_Con", UISearch: UISearch });
            }
        };
    }, [tSortH]);
    return (
        <Fragment>
            {/* Loading Overlay */}
            {REQStrPVDList ? (
                <div className="usrAct-list-progress">
                    <CircularProgress />
                    <p className="usrAct-list-progress-text">
                        Retrieving PVD Conversion list...
                    </p>
                </div>
            ) : null}

            {/* Page Title Space */}
            <div style={{ height: 20 }} />

            {/* Search By Label and Input Container */}
            <div className="labelInput" style={{ marginLeft: 20, marginTop: 30, marginBottom: 15 }}>
                <span className="labelInputText" style={{ width: 100 }}>
                    Search By
                </span>
                <span style={{ paddingRight: 10 }}>:</span>
                <div
                    className="usrAct-search"
                    style={{ marginTop: 0, width: GETxWidthSrch() }}
                >
                    <img
                        src={Images.search.search}
                        alt="search-icon"
                        className="usrAct-list-begin-search"
                        onClick={() => SRCHxPVDAct()}
                    />
                    <input
                        placeholder={"Search by " + tOpSrch}
                        className="usrAct-search-bar"
                        value={tSrch}
                        onChange={event => {
                            SETxSrch(event.target.value);
                        }} onKeyDown={event => {
                            if (event.keyCode === 13) {
                                SETxSrch(event.target.value);
                                SRCHxPVDAct();
                            }
                        }}
                    />
                    {tSrch && tSrch.length > 0 ? (
                        <img
                            src={Images.closeButton.close}
                            alt="cancel-search"
                            className="usrAct-list-cancel-search"
                            onClick={() => SRCHxPVDActClr()}
                        />
                    ) : null}
                </div>
            </div>

            {/* Radio Button Group for Search Options */}
            <div
                className="clients-radio-container"
                style={{ marginLeft: 145, marginBottom: 25 }}
            >
                <RadioInput
                    label="E-mail"
                    value="Email"
                    checked={tOpSrch}
                    setter={SETxOpSrch}
                />
                <span style={{ marginRight: 20 }} />
                <RadioInput
                    label="Username"
                    value="Username"
                    checked={tOpSrch}
                    setter={SETxOpSrch}
                />
                <span style={{ marginRight: 20 }} />
                <RadioInput
                    label="English Name"
                    value="English Name"
                    checked={tOpSrch}
                    setter={SETxOpSrch}
                />
                <span style={{ marginRight: 20 }} />
                <RadioInput
                    label="Thai Name"
                    value="Thai Name"
                    checked={tOpSrch}
                    setter={SETxOpSrch}
                />
                <span style={{ marginRight: 20 }} />
                <RadioInput
                    label="ID No. / Passport No."
                    value="ID No. / Passport No."
                    checked={tOpSrch}
                    setter={SETxOpSrch}
                />
                <span style={{ marginRight: 20 }} />
                <RadioInput
                    label="Mobile"
                    value="Mobile"
                    checked={tOpSrch}
                    setter={SETxOpSrch}
                />
            </div>

            {/* Table Container */}
            {REQStrPVDList ? null : (
                <Table
                    columns={tColumePVD}
                    data={PVDList || []}
                    handleActionClick={SETxActTableClick}
                    handleActionHeaderClick={SETxActHeaderClick}
                    pageSelect={nPageIndex}
                />
            )}

            {/* Pagination */}
            {REQStrPVDList ? null : (
                <div style={{ marginLeft: 20, marginBottom: 30 }}>
                    <CALxPaging />
                </div>
            )}
        </Fragment>
    );
}

const withConnect = connect(
    state => ({
        ...state.analyticDetailReducer
    }),
    {
        REQPVDDetail
    }
);

export default compose(
    withConnect,
    withRouter
)(AnalyticPVDDetail);